import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { SelfEnrollmentsService } from 'services/self-enrollments/self-enrollments.service';
import { getEnrollmentDataForResolver } from 'pages/entry/entry.helpers';
import { PlatformBrandingService } from 'features/organization-settings/platform-branding/platform-branding.service';
import { SelfEnrollmentsPublicResponse } from 'pages/organization/self-enrollments/self-enrollments.interface';

@Injectable()
export class SelfEnrollmentFirstLoginResolverService  {
  constructor(
    private selfEnrollmentsService: SelfEnrollmentsService,
    private router: Router,
    private platformBrandingService: PlatformBrandingService,
  ) {}

  resolve(route: ActivatedRouteSnapshot, routerState: RouterStateSnapshot): Observable<SelfEnrollmentsPublicResponse> {
    return getEnrollmentDataForResolver(
      this.selfEnrollmentsService,
      this.platformBrandingService,
      this.router,
      routerState.url.replace(/\?.*/, ''), // send url without queryParams
    );
  }
}

export const selfEnrollmentFirstLoginResolver: ResolveFn<Observable<SelfEnrollmentsPublicResponse>> = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
) => {
  return inject(SelfEnrollmentFirstLoginResolverService).resolve(route, state);
};
